'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SurflineLogo = require('../SurflineLogo');

var _SurflineLogo2 = _interopRequireDefault(_SurflineLogo);

var _SocialLogos = require('./SocialLogos');

var _SocialLogos2 = _interopRequireDefault(_SocialLogos);

var _ExternalLink = require('./ExternalLink');

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _entitlementsPropType = require('../PropTypes/entitlementsPropType');

var _entitlementsPropType2 = _interopRequireDefault(_entitlementsPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SurflineFooter = function (_Component) {
  (0, _inherits3.default)(SurflineFooter, _Component);

  function SurflineFooter() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SurflineFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SurflineFooter.__proto__ || (0, _getPrototypeOf2.default)(SurflineFooter)).call.apply(_ref, [this].concat(args))), _this), _this.getFooterClassNames = function () {
      return (0, _classnames2.default)({
        'quiver-page-container__footer': true,
        'quiver-page-container__footer--small': _this.props.small
      });
    }, _this.isPremium = function (entitlements) {
      return entitlements.indexOf('sl_premium') > -1;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SurflineFooter, [{
    key: 'render',
    value: function render() {
      var entitlements = this.props.entitlements;


      return _react2.default.createElement(
        'footer',
        { className: this.getFooterClassNames() },
        _react2.default.createElement(
          'ul',
          { className: 'quiver-page-container__footer__icons' },
          _react2.default.createElement(
            'li',
            { className: 'quiver-page-container__footer__icons__logo' },
            _react2.default.createElement(_SurflineLogo2.default, null)
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_SocialLogos2.default, null)
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'quiver-page-container__footer__link-group' },
          _react2.default.createElement(
            'li',
            null,
            'Company'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, { href: 'http://careers.surfline.com/who-we-are/', text: 'About Surfline' })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, { href: 'http://careers.surfline.com/join-our-team/', text: 'Careers' })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, {
              href: 'http://www.surfline.com/advertising/advertise-surfline.cfm',
              text: 'Advertise'
            })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, {
              href: 'http://discover.surfline.com/ocean-consulting/',
              text: 'Ocean Consulting'
            })
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'quiver-page-container__footer__link-group' },
          _react2.default.createElement(
            'li',
            null,
            'Support'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, { href: '//support.surfline.com/', text: 'Support Center' })
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: '/account/' },
              'My Account'
            )
          ),
          !this.isPremium(entitlements) ? _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, { href: 'https://discover.surfline.com/premium/', text: 'Get Premium' })
          ) : null
        ),
        _react2.default.createElement(
          'ul',
          { className: 'quiver-page-container__footer__copyright' },
          _react2.default.createElement(
            'li',
            { className: 'quiver-page-container__footer__copyright__logo' },
            _react2.default.createElement(_SurflineLogo2.default, null)
          ),
          _react2.default.createElement(
            'li',
            null,
            '\xA9 ',
            new Date().getFullYear(),
            ' Surfline/Wavetrak, Inc.'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(_ExternalLink2.default, {
              href: 'http://www.surfline.com/terms_conditions.cfm',
              text: 'Terms of Use'
            }),
            ' and ',
            _react2.default.createElement(_ExternalLink2.default, { href: 'http://www.surfline.com/privacy.cfm', text: 'Privacy Policy' }),
            '.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Partner of USATODAY Lifestyle/Action Sports'
          )
        )
      );
    }
  }]);
  return SurflineFooter;
}(_react.Component);

SurflineFooter.propTypes = {
  entitlements: _entitlementsPropType2.default,
  small: _propTypes2.default.bool
};
SurflineFooter.defaultProps = {
  entitlements: [],
  small: false
};
exports.default = SurflineFooter;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SurflineFooter/SurflineFooter.js
// module id = 330
// module chunks = 0